import { inject, Injectable, Signal } from '@angular/core';
import { FormContainer } from '@ebeihilfe/einreichung-shared/model';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { containersListActions } from '../actions';
import { ContainersListState } from '../reducers/containers-list.reducer';
import { selectContainers, selectContainersError, selectContainersLoading } from '../selectors';

@Injectable()
export class ContainersListFacade {
  private readonly store: Store<ContainersListState> = inject(Store);

  public loadList(): void {
    this.store.dispatch(containersListActions.load());
  }

  public selectList(): Signal<FormContainer[]> {
    return this.store.selectSignal(selectContainers);
  }

  public selectList$(): Observable<FormContainer[]> {
    return this.store.select(selectContainers);
  }

  public selectLoading(): Signal<boolean> {
    return this.store.selectSignal(selectContainersLoading);
  }
  public selectError(): Signal<Error> {
    return this.store.selectSignal(selectContainersError);
  }
}
